import useTimeZoneClock from 'hooks/useTimeZoneClock';
import moment from 'moment';
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { citySelector } from 'slices/citySlice'
import { toCapitalize } from 'views/appointment/view/ViewTable';
import { getBackgroundStyle } from 'components/common/TableColor';
import { useTranslation } from 'react-i18next';

const ViewTable = React.memo(({ item }) => {
    const { t } = useTranslation();

    const fields = [
        { label: t("appointmentDetail.usBasedVendor", { defaultValue: "US Based Vendor" }), name: "us_based", isLocked: 0 },
        { label: t("appointmentDetail.nonUsBasedVendor", { defaultValue: "Non US Based Vendor" }), name: "non_us_based", isLocked: 0 },
        { label: t("appointmentDetail.englishToTarget", { defaultValue: "English To Target Language" }), name: "english_to_target", isLocked: 0 },
        { label: t("appointmentDetail.spanishToTarget", { defaultValue: "Spanish To Target Language" }), name: "spanish_to_target", isLocked: 0 },
        { label: t("appointmentDetail.courtCertified", { defaultValue: "Court Certified" }), name: "court_certified", isLocked: 0 },
        { label: t("appointmentDetail.medicalCertified", { defaultValue: "Medical Certified" }), name: "medical_certified", isLocked: 0 },
    ];

    const { city: cities } = useSelector(citySelector);
    // const timeZone = useTimeZoneClock(item?.datetime);
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');

    const cityName = React.useMemo(() => {
        const cityName = cities?.find(city => city.id === item?.appointment_details?.facility?.city_id)?.name;
        return cityName;

    }, [item?.facility?.city_id])

    const dynamicFields = React.useMemo(() => {
        const dynamic_fields = item?.appointment_details?.dynamic_fields && JSON.parse(item?.appointment_details?.dynamic_fields) || []
        const dynamicFields = dynamic_fields?.map(field => ({ name: field?.name, value: field?.value }));
        return dynamicFields || [];
    }, [item?.appointment_details?.dynamic_fields])

    const renderTableItem = (title, text) => (
        <>
            <td className='bg-primary-secondary'>
                <h4>{title}</h4>
            </td>
            <td className='bg-primary-secondary'>{text || t("common.nA", { defaultValue: 'N/A' })}</td>
        </>

    )

    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };

    const getStatusText = (status) => {
        if (!status) return t("common.nA", { defaultValue: "N/A" });
        const normalized = status.toString().toLowerCase();
        return t(`status.${normalized}`, { defaultValue: status });
    };

    return (

        <>



            <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
                <div className="row_dash_1" style={rowDash1Style}>
                    <div className="card_table" style={marginTopZero}>

                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.facility", { defaultValue: "Facility:" })} </td>
                                        <td className="bg-primary-secondary">{item?.appointment_details?.facility?.facility_name || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.department", { defaultValue: "Department:" })} </td>
                                        <td className="bg-primary-secondary">{item?.appointment_details?.department?.department_name || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    {item?.type === 'In Person' && (
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.address", { defaultValue: "Address:" })}</td>
                                        <td className="bg-primary-secondary">{item.appointment_details?.address || item.appointment_details?.facility?.street_address || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="interpreter p-4">
                            <h2>{t("dashboard.vendor", { defaultValue: "Vendor" })}</h2>
                        </div>
                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.vendorName", { defaultValue: "Vendor Name:" })} </td>
                                        <td className="bg-primary-secondary">
                                            {item?.interpreter?.vendor_type === 'agency' && (item?.agency_interpreter_name || item?.agencyInterpreter?.name)
                                                ? (item?.agency_interpreter_name || item?.agencyInterpreter?.name)
                                                : item?.interpreter?.vendor
                                                    ? item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name
                                                    : item?.interpreter?.user?.name || t("common.nA", { defaultValue: 'N/A' })}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.vendorEmail", { defaultValue: "Vendor Email:" })} </td>
                                        <td className="bg-primary-secondary">
                                            {item?.interpreter?.vendor_type === 'agency'
                                                ? (item?.agencyInterpreter?.email || item?.agency_interpreter_email || t("common.nA", { defaultValue: 'N/A' }))
                                                : item?.interpreter?.user?.email || t("common.nA", { defaultValue: 'N/A' })}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.vendorPhone", { defaultValue: "Vendor Phone:" })} </td>
                                        <td className="bg-primary-secondary">
                                            {item?.interpreter?.vendor_type === 'agency'
                                                ? (item?.agencyInterpreter?.phone || item?.agency_interpreter_phone || t("common.nA", { defaultValue: 'N/A' }))
                                                : item?.interpreter?.phone || t("common.nA", { defaultValue: 'N/A' })}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.checkinDate", { defaultValue: "Checkin Date:" })}</td>
                                        <td className="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.checkinTime", { defaultValue: "Checkin Time:" })}</td>
                                        <td className="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.checkoutDate", { defaultValue: "Checkout Date:" })}</td>
                                        <td className="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || t("common.nA", { defaultValue: 'N/A' })}</td>

                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.checkoutTime", { defaultValue: "Checkout Time:" })}</td>
                                        <td className="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className="card_table" style={marginTopZero}>
                        <div className="Table_data_show Table_data_show1 pt-0 ">
                            <table className="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                                <tbody>
                                    <tr>
                                        <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>{t("table.status", { defaultValue: "Status" })}: </td>
                                        <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status == 'cancelled' ? item?.appointment_details?.is_billable_cancel == 1 ? t("appointment.cancelledBillable", { defaultValue: 'Cancelled Billable' }) : t("status.cancelled", { defaultValue: 'Cancelled' }) : getStatusText(item?.status)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>



                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    {fields.map((field, index) => (
                                        <tr key={index}>
                                            <td className="bg-primary-secondary" style={{ width: "40%" }}>
                                                {field.label}
                                            </td>
                                            <td className="bg-primary-secondary">
                                                {item?.appointment_details?.[field.name] === 1
                                                    ? t("appointmentDetail.yes", { defaultValue: "Yes" })
                                                    : item?.appointment_details?.[field.name] === 0
                                                        ? t("appointmentDetail.no", { defaultValue: "No" })
                                                        : t("common.nA", { defaultValue: "N/A" })}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>


                        <div className="Table_data_show Table_data_show1 pt-0 ">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.requesterName", { defaultValue: "Requester Name:" })} </td>
                                        <td className="bg-primary-secondary">{item.appointment_details?.requester_name || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.requesterEmail", { defaultValue: "Requester Email:" })} </td>
                                        <td className="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.requesterPhone", { defaultValue: "Requester Phone:" })}</td>
                                        <td className="bg-primary-secondary">{item.appointment_details?.requester_phone || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="row_dash_1" style={rowDash2Style}>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "20%" }}>{t("appointmentDetail.estimatedDuration", { defaultValue: "Estimated Duration:" })} </td>
                                    <td className="bg-primary-secondary" >{item?.estimated_duration || t("common.nA", { defaultValue: 'N/A' })} {item?.estimated_duration_unit || ''} </td>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.rescheduledReason", { defaultValue: "Rescheduled Reason:" })} </td>
                                    <td className="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || t("common.nA", { defaultValue: 'N/A' })}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.cancelReason", { defaultValue: "Cancel reason:" })} </td>
                                    <td className="bg-primary-secondary">{item?.appointment_details?.cancel_reason || t("common.nA", { defaultValue: 'N/A' })}</td>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.notes", { defaultValue: "Notes:" })}</td>
                                    <td className="bg-primary-secondary">{item.appointment_assign?.notes || t("common.nA", { defaultValue: 'N/A' })}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.cncReason", { defaultValue: "CNC Reason:" })}</td>
                                    <td className="bg-primary-secondary">{item?.appointment_details?.cnc_reason || t("common.nA", { defaultValue: 'N/A' })}</td>
                                </tr>
                                {item?.appointment_details?.admin_notes &&
                                <tr>
                                    <td className="bg-primary-secondary" colSpan={2}>{t("appointmentDetail.appointmentNotes", { defaultValue: "Appointment Notes:" })}</td>
                                    <td className="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.admin_notes || t("common.nA", { defaultValue: 'N/A' })}</td>
                                </tr>
                                }

                                {item?.status === "completed" && (
                                    <>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.feedbackRating", { defaultValue: "Feedback Rating:" })}</td>
                                        <td className="bg-primary-secondary">{item.feedback?.rating ? `${item.feedback?.rating} ${t("appointmentDetail.stars", { defaultValue: "Stars" })}` : t("common.nA", { defaultValue: 'N/A' })}</td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.feedbackComment", { defaultValue: "Feedback Comment:" })}</td>
                                        <td className="bg-primary-secondary">
                                            {item.feedback?.comments ?? t("common.nA", { defaultValue: 'N/A' })}
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={2}>{t("appointmentDetail.feedbackSuggestion", { defaultValue: "Feedback Suggestion:" })}</td>
                                        <td className="bg-primary-secondary" colSpan={2}>
                                            {item.feedback?.suggestions ?? t("common.nA", { defaultValue: 'N/A' })}
                                        </td>
                                    </tr>
                                    </>
                                )}

                            </tbody>
                        </table>
                    </div>
                </div>

                { ( dynamicFields.length > 0 && dynamicFields[0]?.name !== null)  &&    
                    <div className="row_dash_1" style={rowDash2Style}>
                        <div className="Table_data_show Table_data_show1 pt-0">

                            <table className="bg-primary-secondary table">
                                {item?.id &&
                                    <tbody>
                                        <tr >
                                            {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                                renderTableItem(`${t("appointmentDetail.dynamicField", { defaultValue: "Dynamic Field" })} ${index + 1}`, `${field.name}: ${field.value || t("common.nA", { defaultValue: 'N/A' })}`)
                                            ))}
                                        </tr>
                                    </tbody>
                                }
                            </table>
                        </div>
                    </div>
                } 

                {item?.type !== "OPI Pre Scheduled" && item?.appointment_custom_pricing && (
                    <>
                        <div className="interpreter p-4">
                            <h2>{t("appointmentDetail.customPricing", { defaultValue: "Custom Appointment Pricing:" })}</h2>
                        </div>

                        <div className="row_dash_1" style={rowDash2Style}>
                            <div className="Table_data_show Table_data_show1 pt-0">
                                <table className="bg-primary-secondary table">
                                    <tbody>
                                        <tr>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.mileage", { defaultValue: "Mileage (km):" })}</td>
                                            <td className="bg-primary-secondary">{item.appointment_custom_pricing?.mileage ?? '0'}</td>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.mileageRate", { defaultValue: "Mileage Rate:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.mileage_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.mileageTotal", { defaultValue: "Mileage Total:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.mileage_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.travelHours", { defaultValue: "Travel Hours:" })}</td>
                                            <td className="bg-primary-secondary">{item.appointment_custom_pricing?.travel_hours ?? '0'}</td>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.travelRate", { defaultValue: "Travel Rate:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.travel_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.travelTotal", { defaultValue: "Travel Total:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.travel_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.minDuration", { defaultValue: "Min Duration (hrs):" })}</td>
                                            <td className="bg-primary-secondary">{item.appointment_custom_pricing?.min_duration ?? '0'}</td>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.ratePerHour", { defaultValue: "Rate per hr:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.duration_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">{t("appointmentDetail.sessionTotal", { defaultValue: "Session Total:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.session_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>{t("appointmentDetail.subtotal", { defaultValue: "Subtotal:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.sub_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>{t("appointmentDetail.discount", { defaultValue: "Discount (%):" })}</td>
                                            <td className="bg-primary-secondary">
                                                {(item.appointment_custom_pricing?.discount ?? 0) + '%'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>{t("appointmentDetail.appointmentTotal", { defaultValue: "Appointment Total:" })}</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.appointment_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </>
                )}


            </div>


            {/* <div className="Table_data_show overflow-auto">
                <table className="table table-bordered">
                    {item?.id &&
                        <tbody>
                            <tr>
                                {renderTableItem("Appointment ID", item?.appid)}
                                {renderTableItem("Status", toCapitalize(item?.status))}
                            </tr>
                            <tr>
                                {renderTableItem("Date/Time", item?.datetime)}
                                {renderTableItem("Client", item?.accounts?.user?.name || "N/A")}
                            </tr>
                            <tr>
                                {renderTableItem("Appointment Type", item?.type)}
                                {item?.appointment_details?.video_link ? renderTableItem("Video link", <Link to={item?.appointment_details?.video_link}>{item?.appointment_details?.video_link}</Link>) : renderTableItem("Video link", "N/A")}
                            </tr>
                            <tr>
                                {renderTableItem("Language", item?.language?.name)}
                                {renderTableItem("Facility", item?.appointment_details?.facility?.facility_name || 'N/A')}
                            </tr>
                            <tr>
                                {renderTableItem("Department", item?.appointment_details?.department?.department_name)}
                                {renderTableItem("Department Text", item?.appointment_details?.department_text)}
                            </tr>
                            <tr>
                                {renderTableItem("US based", item?.appointment_details?.us_based == 1 ? 'Yes' : "No")}
                                {renderTableItem("Non us based", item?.appointment_details?.non_us_based == 1 ? 'Yes' : "No")}
                            </tr>
                            <tr>
                                {renderTableItem("English to target", item?.appointment_details?.english_to_target == 1 ? 'Yes' : "No")}
                                {renderTableItem("Spanish to target", item?.appointment_details?.spanish_to_target == 1 ? 'Yes' : "No")}
                            </tr>
                            <tr>
                                {renderTableItem("Court certified", item?.appointment_details?.court_certified == 1 ? 'Yes' : "No")}
                                {renderTableItem("Medical certified", item?.appointment_details?.medical_certified == 1 ? 'Yes' : "No")}
                            </tr>
                            <tr>
                                {renderTableItem("Interpreter Name", item?.interpreter?.user?.name || 'N/A')}
                                {renderTableItem("Interpreter Email", item?.interpreter?.user?.email || 'N/A')}
                            </tr>
                            <tr>
                                {renderTableItem("Interpreter Gender", item.appointment_details?.interpreter_gender)}
                                {renderTableItem("Interpreter Notes", item?.appointment_details?.notes)}
                            </tr>
                            <tr>
                                {renderTableItem("Reschedule reason", item?.appointment_details?.reschedule_reason)}
                                {renderTableItem("Cnc reason", item?.appointment_details?.cnc_reason)}
                            </tr>
                            <tr>
                                {renderTableItem("Dnc reason", item?.appointment_details?.dnc_reason)}
                                {renderTableItem("Cancel reason", item?.appointment_details?.cancel_reason)}
                            </tr>
                            <tr>
                                {renderTableItem("Estimated Duration", `${item.estimated_duration} minutes`)}
                                {renderTableItem("Requester Name", item.appointment_details?.requester_name)}
                            </tr>
                            <tr>
                                {renderTableItem("Requester Email", item.appointment_details?.requester_email)}
                                {renderTableItem("Requester Phone", item.appointment_details?.requester_phone)}
                            </tr>
                            <tr>
                                {renderTableItem("Address", item.appointment_details?.address)}
                                {renderTableItem("Auto assign", item?.appointment_details?.auto_assign == 1 ? 'Yes' : "No")}
                            </tr>
                        </tbody>
                    }
                </table>

                <table className="table table-bordered mt-4">
                    {item?.id &&
                        <tbody>
                            <tr>
                                {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                    renderTableItem(`Dynamic Field ${index + 1}`, `${field.name}: ${field.value}`)
                                ))}
                            </tr>
                        </tbody>
                    }
                </table>
            </div> */}
        </>
    )

})

export default ViewTable